import { useMatches } from "@tanstack/react-router";
import { municipalityBySlug } from "@/data/municipalities";
import { LOCAL_FACTS_KEY, type LocalFacts } from "@/lib/localFactsText";

/**
 * Lokala fakta för kommunsidor, att anropa i route loaders. Kommundatan och
 * prisfrågorna laddas dynamiskt så att de inte hamnar i huvudpaketet.
 * Returnerar null för slugar som inte är kommuner och vid fel (sidan
 * renderas då utan blocket).
 */
export async function localFactsLoader(slug: string): Promise<LocalFacts | null> {
  if (!municipalityBySlug(slug)) return null;
  try {
    const { loadLocalFacts } = await import("@/lib/localFactsData");
    return await loadLocalFacts(slug);
  } catch (err) {
    console.error("Lokala fakta kunde inte laddas", err);
    return null;
  }
}

/** Närmaste matchade rutt (inifrån och ut) som har laddat lokala fakta. */
export function useLocalFactsSeed(): LocalFacts | null {
  return useMatches({
    select: (matches) => {
      for (let i = matches.length - 1; i >= 0; i--) {
        const data = matches[i]?.loaderData as Record<string, unknown> | undefined;
        const facts = data?.[LOCAL_FACTS_KEY] as LocalFacts | null | undefined;
        if (facts) return facts;
      }
      return null;
    },
  });
}
